<template>
  <div class="discuss-publish">
    <div class="discuss-content">
      <el-form :model="form" :rules="rules" ref="form" class="discuss-content-form">
        <div class="discuss-content-form-item">
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="title"><span class="red">*</span> 标题</div>
                <el-form-item prop="title">
                  <el-input
                    :maxlength="50"
                    show-word-limit
                    v-model="form.title"
                    placeholder="请输入标题"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12" class="labels">
                <div class="title"><span class="red">*</span>话题</div>
                <el-form-item prop="labels">
                  <select-labels @set-label="addLabel" :limit="2" :default-labels="form.labels"></select-labels>
                </el-form-item>
              </el-col>
            </el-row>
        </div>
        <div class="discuss-content-form-item">
          <div class="title">正文（非必填）</div>
          <el-form-item prop="content">
            <editor :value.sync="form.content" />
          </el-form-item>
        </div>
        <div class="form-btns">
            <el-button type="primary" class="form-button" :loading="submitLoading" @click="handleSubmit">立即发布</el-button>
            <!-- <el-button type="primary" plain class="form-button" @click="$router.go(-1)">&nbsp;&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</el-button> -->
        </div>
    </el-form>
    </div>
  </div>
</template>

<script>
import SelectLabels from './SelectLabels';
import Editor from '@/components/Editor';
import { publishTopic } from '@/api/forum';
export default {
  name: 'DiscussPublish',
  props: {
    detail: {
      type: Object,
      required: false,
      default: () => null,
    }
  },
  components: { 
    Editor,
    SelectLabels,
  },
  data: () => {
    const validateLabels = (rule, value, callback) => {
      if (!value || !value.length) {
        callback(new Error('请选择话题'));
      } 
      callback();
    }
    return {
      // 表单数据
      form: {
        content: "",
        labels: [],
        title: "",
        type: 1,
        id: '',
      },
      // 表单验证规则
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' },
          { min: 2, max: 50, message: '标题长度为2-50位', trigger: ['blur', 'change'] },
          {
            pattern: /^[\S]{2,50}$/,
            message: '标题不支持空格哦',
            trigger: ['blur', 'change']
          }
        ],
        labels: [
          { required: true, message: '请选择话题', trigger: ['blur', 'change'] },
          { validator: validateLabels, trigger: 'blur' },
        ],
      },
      // 提交时的加载动画
      submitLoading: false,
      // 是否展示添加话题的popover窗
      showPopover: false,
      // 是否已点击发布
      submitAction: false,
    };
  },
  watch: {
    detail: {
      immediate: true,
      deep: true,
      handler() {
        if (this.detail && this.detail.id) {
          this.form.content = this.detail.content;
          this.form.title = this.detail.title;
          this.form.labels = this.detail.labels;
          this.form.id = this.detail.id;
        }
      }
    }
  }, 
  methods: {
    beforeRouteLeave(to, from, next) {
      if (!this.submitAction && !this.isEmptyForm()) {
        setTimeout(() => {
          this.$confirm('当前页面已有内容，是否确认离开此页面？')
            .then(() => {
              next(true);
            })
            .catch(() => {
              next(false);
            });
        }, 200)
      } else {
        next();
      }
    },
    isEmptyForm() {
      return !this.form.title && !this.form.content && !this.form.labels.length;
    },
    // 点击添加话题
    addLabel(labels) {
      this.form.labels = labels;
      this.$refs.form.validateField('labels');
    },
    // 点击立即发布
    handleSubmit() {
      this.$refs.form.validate().then(() => {
        const params = {...this.form};

        params.labels = this.form.labels.map(label => ('' + label.id).startsWith('random-') ? `#${label.name}` : label.id).join();
        this.submitLoading = true;
        publishTopic(params).then(() => {
          this.$message.success('发布成功');
          this.submitAction = true;
          this.$router.push(`/forum/index/${this.form.type}`);
        }).finally(() => {
          this.submitLoading = false;
        });
      });
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../forum.scss";
.discuss-publish {
  .discuss-content {
    flex: 1;
  }
  .el-button {
    padding: 7px 23px;
  }
}
</style>
